<!-- eslint-disable no-console -->
<template>
    <div> 
        <gat-select v-model="selectedMappingId" :items="mappingDeffinitions" label="Mapping deffinitions" textFieldName="name" codeFieldName="id"  />
        <!-- <gat-edit :value="JSON.stringify(selectedMapping)" size="xs12" label="map settings" rows="10" />  -->
        <json-viewer :value="selectedMapping" :expand-depth=5 copyable />
    </div>
        
 </template>
 
 <script >
 import Vue from "vue";
 import JsonViewer from 'vue-json-viewer'
import { apiGet } from "../../../dal";
//  import GatEdit from "../../GatComponents/GatEdit.vue";
import GatSelect from "../../../GatComponents/GatSelect.vue";
 
 
 
 
 export default Vue.extend({
    name: "DataMappingView",
    components: {  GatSelect, JsonViewer},
    props: {parsedData: Object, csvData: String},
    data() {
       return {
            mappingDeffinitions: [],
            selectedMappingId: null
       };
    },
 
    activated() {},
 
    mounted() {
     this.fetchMappingFormats();
    },

    watch: {
        csvData: function(val){
            this.trySetMappingFormatFromCsvHeading(val);
        },
        
        selectedMappingId: function(val){
            if(val){
                const mapping = this.mappingDeffinitions.find(x => x.id == val);
                this.$emit("mapping-changed", mapping);
            }
        },
    
    },
    
  
    deactivated() {},
 
    computed: {
      gridColumns() {        
        let columns = [];
        if(this.parsedData && this.parsedData.meta && this.parsedData.meta.fields.length > 0)
        for (const key in this.parsedData.meta.fields) {
            const field = this.parsedData.meta.fields[key];
            
            columns.push({ header: field, field: field });
        }  
        return columns;
      },

      selectedMapping(){
        var mapping = this.mappingDeffinitions.find(x => x.id == this.selectedMappingId);
        if(mapping){
            return mapping;
        }
        return {};
      },

      structuredData(){
        return this.parsedData.data;      
      }

    },
 
    methods: {
        fetchMappingFormats(){          
          apiGet("import/mappings").then((response) => {
            var mappings = response;            
            this.mappingDeffinitions = mappings;
            this.trySetMappingFormatFromCsvHeading(this.csvData);
          });
        },

        trySetMappingFormatFromCsvHeading(csvData){
            const firstRow = csvData.split("\n")[0];            
            const matchedMapping = this.mappingDeffinitions.find(x => firstRow.includes(x.headingRaw));
            if(matchedMapping){
                this.selectedMappingId = matchedMapping.id;
            }
        }
       
      },
 });

 </script>
 
 <style scoped>
   .gridCheckbox {
      margin-top: 12px;
      margin-bottom: -12px;
   }

   .gat-grid{
    max-height: 300px;
    overflow-y: auto;
   }

 </style>
 